import { useTranslation } from 'next-i18next'

import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'
import { ButtonSecondary } from '~/components/Buttons/ButtonSecondary'
import ROUTES from '~/shared/constants/routes.const'

import { Exam } from './Exams.types'

export default function ExamEntry({ classroom, problemUrl, solutionUrl, term, isLoggedIn }: Exam): React.ReactElement {
  const { t } = useTranslation('exams')

  const renderButtons = (): React.ReactElement => {
    if (isLoggedIn) {
      return (
        <>
          {problemUrl && (
            <ButtonPrimary href={problemUrl} isFullWidth link="external" size="small">
              {t('task')}
            </ButtonPrimary>
          )}
          {solutionUrl && (
            <ButtonSecondary href={solutionUrl} isFullWidth link="external" size="small">
              {t('solution')}
            </ButtonSecondary>
          )}
        </>
      )
    }
    return (
      <ButtonSecondary href={ROUTES.LOGIN} isFullWidth link="internal" size="small">
        {t('logIn')}
      </ButtonSecondary>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h5>{term}</h5>
        <span className="py-1 px-4 rounded bg-purple-light text-2.5">{classroom}</span>
      </div>
      <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">{renderButtons()}</div>
    </div>
  )
}
